import type { ComponentProps, MouseEvent } from "react";

import type { List, Overlay, OverlayFooter, OverlayHeader } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

type ListProps = Partial<ComponentProps<typeof List>>;

type FieldSelectListPropsOption = ListProps & {
  customPlaceholder?: string;
  customNoResultsText?: string;
  customTimeout?: number;
  inputProps?: ListProps["inputProps"];
};

export const FieldSelectListProps = ({
  customPlaceholder,
  customNoResultsText,
  customTimeout,
  inputProps,
  ...restProps
}: FieldSelectListPropsOption = {}): ListProps => ({
  enableSearch: true,
  listWidth: "fill",
  noResultsText: customNoResultsText || appstr("nomatches"),
  inputProps: {
    placeholder: customPlaceholder || appstr("findfield"),
    timeout: customTimeout !== undefined ? customTimeout : 300,
    ...inputProps
  },
  ...restProps
});

type ClickHandler<T> = (option: T) => void;
export const handleListItemClick = <T>(
  onSingleClick: ClickHandler<T>,
  onDoubleClick: ClickHandler<T>
) => {
  return (option: T, event: MouseEvent) => {
    switch (event.detail) {
      case 1:
        onSingleClick(option);
        break;
      case 2:
        onDoubleClick(option);
        break;
    }
  };
};

type PopoverOverlayProps = {
  title?: string;
  testId?: string;
  headerProps?: ComponentProps<typeof OverlayHeader>;
  footerProps?: ComponentProps<typeof OverlayFooter>;
  sizeProps?: ComponentProps<typeof Overlay>["sizeProps"];
  otherProps?: Partial<ComponentProps<typeof Overlay>>;
};

const defaultSizeProps = {
  maxWidth: 400,
  minHeight: 80,
  maxHeight: 275,
  minWidth: 380
};

export const GetPopoverOverlayProps = ({
  title,
  headerProps,
  footerProps,
  sizeProps,
  otherProps
}: PopoverOverlayProps = {}) => {
  return {
    headerProps: {
      title: title,
      modifier: "default",
      ...headerProps
    },
    footerProps: {
      ...footerProps
    },
    className: "oc-popover-content",
    sizeProps: {
      ...defaultSizeProps,
      ...sizeProps
    },
    padding: "2px 0",
    ...otherProps
  };
};
